import { render, staticRenderFns } from "./ServicedMortgage.vue?vue&type=template&id=088d5252&scoped=true&"
import script from "./ServicedMortgage.vue?vue&type=script&lang=js&"
export * from "./ServicedMortgage.vue?vue&type=script&lang=js&"
import style0 from "./ServicedMortgage.vue?vue&type=style&index=0&id=088d5252&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d5252",
  null
  
)

export default component.exports